/* eslint-disable consistent-return */
import $ from 'jquery';

const Tabs = function Tabs({ selector, destination, isSticky }) {
  const init = () => {
    this.isSticky = isSticky;
    this.element = document.querySelector(selector);
    this.destination = document.querySelector(destination);
    // this.element.firstElementChild.insertAdjacentHTML('beforeend', '<span class="magicLine"></span>');
    this.magicLine = this.element.querySelector('.magicLine');
    this.tabs = this.element.querySelectorAll('.tab');
    this.tabSections = [...this.tabs].map((tab) => this.destination.querySelector(tab.dataset.scroll));
    this.eventsInit();

    return this;
  };

  this.eventsInit = () => {
    const self = this;
    const { element } = this;
    element.querySelectorAll('.tab').forEach((item) =>
      item.addEventListener('click', function clickedTab(event) {
        self.clickTab(this, event);
      }),
    );
    if (this.isSticky) {
      window.onscroll = this.setTabsSticky;
    } else {
      this.setElementActive(element.querySelectorAll('.tab')[0]);
    }
  };

  this.clearActive = () => {
    [this.element, this.destination].forEach((wrapper) => {
      const currentActive = wrapper.querySelector(':scope > .--active');
      if (currentActive) {
        currentActive.classList.remove('--active');
      }
    });
  };

  this.setElementActive = (button) => {
    this.clearActive();
    button.classList.add('--active');
    this.destination.querySelector(button.dataset.scroll).classList.add('--active');
    this.moveMagicLine();
  };

  this.moveMagicLine = () => {
    if (!this.magicLine) {
      return;
    }
    const activeElement = this.element.querySelector('.--active');

    if (activeElement) {
      this.magicLine.style.width = `${activeElement.offsetWidth}px`;
      this.magicLine.style.left = `${activeElement.offsetLeft}px`;
    } else {
      this.magicLine.style.width = '';
      this.magicLine.style.left = '';
    }
  };

  this.clickTab = (button, e) => {
    e.preventDefault();
    this.setElementActive(button);
    if (!this.isSticky) {
      $('html, body').animate(
        {
          scrollTop: $(this.destination).offset().top - 139,
        },
        500,
      );
      return;
    }
    $('html, body').animate(
      {
        scrollTop: $(button.dataset.scroll).offset().top - 139,
      },
      500,
    );
  };

  this.setTabsSticky = () => {
    const { top } = this.element.parentNode.getBoundingClientRect();
    const { bottom } = this.destination.getBoundingClientRect();
    if (top <= 60) {
      if (bottom <= 60) {
        this.element.classList.add('--out');
      } else {
        this.element.classList.remove('--out');
      }
      this.element.classList.add('--sticky');
    } else {
      this.element.classList.remove('--sticky');
      this.element.classList.remove('--out');
      this.clearActive();
      this.moveMagicLine();
    }

    let closestZero = null;
    this.tabSections.forEach((section) => {
      if (!section) return false;

      if (section.getBoundingClientRect().top <= 140) {
        if (!closestZero) {
          closestZero = section;
        } else if (section.getBoundingClientRect().top > closestZero.getBoundingClientRect().top) {
          closestZero = section;
        }
      }
    });

    if (closestZero) {
      const currentActiveTab = this.element.querySelector('.--active');
      const newActiveTab = this.element.querySelector(closestZero.dataset.selector);

      if (!currentActiveTab || currentActiveTab !== newActiveTab) {
        this.setElementActive(newActiveTab);
      }
    }
  };

  return init();
};

export default Tabs;
